export default function innerHTML (content) {
  return {
    dangerouslySetInnerHTML: {
      __html: content
    }
  }
}
